import React, { useEffect } from 'react';

import { useFormik } from 'formik';

import {
  getUserSecondaryContact,
  updatePharmactContact,
  userActions,
  userSecondaryContact,
} from '@pharmaplan/common';
import { userInitialState } from '@pharmaplan/common/reducers/userReducer';

import useDisableProfileSave from '../../../../hooks/useDisableProfileSave';
import { ICommonProfile } from '../../PharmacistFlow/General/General';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { SecondaryValidator } from '../../FormValidation';
import ProfileForm from '../../ProfileForm';

const Secondary = ({ setSelected }: ICommonProfile) => {
  const dispatch = useAppDispatch();
  const secondary = useAppSelector(userSecondaryContact);

  const formik = useFormik({
    initialValues: { ...userInitialState?.secondaryContact },
    onSubmit: (values) => {
      dispatch(updatePharmactContact({ values, type: 'secondarycontact' }));
    },
    enableReinitialize: true,
    validationSchema: SecondaryValidator(),
  });

  const { disabled } = useDisableProfileSave({
    action: userActions.updateCommonContact,
    mutableValues: formik.values,
    initialValue: secondary,
  });

  useEffect(() => {
    dispatch(getUserSecondaryContact());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formik.setValues({ ...secondary });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondary]);

  return (
    <ProfileForm
      setSelected={setSelected}
      disableSave={disabled}
      selected="secondary"
      formik={formik}
    />
  );
};

export default Secondary;
